var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tau-spin',{staticClass:"default-spin",attrs:{"min":"1902","max":"2050","value":_vm.year,"loop":"enabled","roll-height":"custom","item-height":"50","momentum-level":"1","duration":"500"}})}
var staticRenderFns = []

export { render, staticRenderFns }